import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.div`
  margin: 30px 0;
`

export const CardHeader = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    margin: 0 8px;
    height: 58px;
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
    border-radius: ${theme.border.radius} ${theme.border.radius} 0 0;
    font-family: ${theme.font.montserrat};
    font-size: ${theme.font.sizes.normal};
    font-weight: ${theme.font.xbold};

    > button {
      display: flex;
      align-items: center;
      background: none;

      svg {
        width: 20px;
        height: 20px;
        cursor: pointer;
      }
    }
  `}
`

export const CardBody = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 10px;
    margin: -3px 8px 0 8px;
    padding: 12px;
    border-radius: 0 0 ${theme.border.smallRadius} ${theme.border.smallRadius};
    background: ${theme.colors.mainBg};
    .tooptip-custom {
      width: 100%;
      background: ${theme.colors.white} !important;
      opacity: 1 !important;
      text-align: left;
      max-width: 260px;
      box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.2);
      border-radius: ${theme.border.radius};
      font-family: ${theme.font.montserrat};
      font-size: ${theme.font.sizes.xxxsmall};
      font-weight: ${theme.font.normal};
    }

    .checkbox {
      grid-column-start: 5;
      grid-column-end: 6;
      display: flex;
      flex-direction: row-reverse;
      label {
        font-size: 14px;
        word-break: normal;
        width: max-content;
      }

      button.tooltip {
        margin-left: 5px;
      }
    }

    .textarea-container {
      grid-column-start: 1;
      grid-column-end: 6;
      grid-row-start: 3;
    }

    ${media.lessThan('medium')`
      grid-template-columns: repeat(2, 1fr);
      .checkbox {
        padding-left:0%;
      grid-column-start: 2;
      grid-column-end: 3;
      display: flex;
      flex-direction: row-reverse;
      label {
        font-size: 13px;
        word-break: normal;
      }
    }
      .textarea-container {
        grid-column-start: 1;
        grid-column-end: 3;
        grid-row-start: 5;
      }
    `}

    ${media.lessThan('small')`
      display: flex;
      flex-direction: column;
    `}
    .import-files {
      display: flex;
      grid-column-start: 5;
      grid-column-end: 6;
      align-items: center;
      ${media.lessThan('medium')`
      margin-left: 30%;
      grid-column-start: 2;
      grid-column-end: 3;
      grid-row-start: 6;
      `}
      > Button {
        width: 20%;
        background: ${theme.colors.mainBg};
        border-radius: 0;

        &:hover {
          filter: brightness(1);
        }
      }
    }
  `}
`
export const HasHelpButtons = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${theme.colors.black};
    color: ${theme.colors.white};
    font-size: ${theme.font.sizes.xxsmall};
    border-radius: 50%;
    height: 32px;
    width: 32px;
    cursor: pointer;
  `}
`
